class JobCardShowView {
  constructor($el) {
    if (!$el.length) return

    this.$root = $el
    this.jobId = this.getJobId()

    this.initClipboard()
    this.initFileUpload()
    this.initDocumentRemoval()
    this.initNotesAutoSave()
    this.initUserNoteToggle()
  }

  getJobId() {
    const url = window.location.pathname
    return url.substring(url.lastIndexOf('/') + 1)
  }

  initClipboard() {
    window.copyToClipboard = this.copyToClipboard.bind(this)
    window.outFunc = this.outFunc.bind(this)
  }

  copyToClipboard(element) {
    const $el = $(element)
    const text = $el.closest('td').prev('td').text()
    const $dummy = $('<textarea>').appendTo('body')

    $dummy.val(text).select()
    document.execCommand('copy')
    $dummy.remove()

    $el
      .find('span')
      .first()
      .html('Copied: ' + text)
  }

  outFunc(element) {
    $(element).find('span').first().html('Copy to clipboard')
  }

  initFileUpload() {
    this.$fileInput = this.$root.find('.auto-apppy-documents__input')
    if (!this.$fileInput.length) return

    this.$fileInput.on('change', event => {
      const files = event.target.files
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        const src = URL.createObjectURL(file)
        this.createPreviewNode(src, file.name, file)
      }
      this.$fileInput.val('')
    })
  }

  createPreviewNode(src, fileName, file) {
    const $fileDiv = $('<div>').addClass('file')
    $('#job-card-docuemnt-upload__preview').append($fileDiv)

    this.uploadFile(file, $fileDiv)

    const $link = $('<a>', { download: fileName, href: src }).text(fileName)

    const $svg = $(
      '<svg width="24" height="24" fill="none" viewBox="0 0 24 24">' +
        '<g stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">' +
        '<path d="m8 8 8 8"></path><path d="m16 8-8 8"></path></g></svg>',
    )

    const $removeButton = $('<a>', { href: 'javascript:void(0)' })
      .addClass('js-remove-document')
      .css('margin-left', '20px')
      .append($svg)

    const $divLink = $('<div>').css('display', 'flex').append($link).append($removeButton)
    $fileDiv.append($divLink)
  }

  uploadFile(file, $fileDiv) {
    const formData = new FormData()
    formData.append('file', file)

    $.ajax({
      url: `/admin/job_cards/${this.jobId}/upload_document`,
      method: 'POST',
      data: formData,
      processData: false,
      contentType: false,
      success: data => {
        $fileDiv.attr('id', data['id'])
      },
    })
  }

  initDocumentRemoval() {
    this.$previewContainer = $('#job-card-docuemnt-upload__preview')
    if (!this.$previewContainer.length) return

    this.$previewContainer.on('click', '.js-remove-document', evt => {
      const $fileNode = $(evt.target).closest('.file')
      if (!$fileNode.length) return

      const documentId = $fileNode.attr('id')
      this.deleteFile(documentId)
      $fileNode.remove()
    })
  }

  deleteFile(documentId) {
    $.ajax({
      url: `/admin/job_cards/${this.jobId}/delete_document/${documentId}`,
      method: 'DELETE',
    })
  }

  initNotesAutoSave() {
    this.$notesInput = this.$root.find('.text-area').eq(0)
    this.$internalNotesInput = this.$root.find('.text-area').eq(1)
    this.notesTimer = null
    this.internalNotesTimer = null

    if (this.$notesInput.length) {
      this.$notesInput.on('keyup', () => {
        clearTimeout(this.notesTimer)
        this.notesTimer = setTimeout(() => this.saveNote(), 1000)
      })
      this.$notesInput.on('keydown', () => {
        clearTimeout(this.notesTimer)
      })
    }

    if (this.$internalNotesInput.length) {
      this.$internalNotesInput.on('keyup', () => {
        clearTimeout(this.internalNotesTimer)
        this.internalNotesTimer = setTimeout(() => this.saveInternalNote(), 1000)
      })
      this.$internalNotesInput.on('keydown', () => {
        clearTimeout(this.internalNotesTimer)
      })
    }
  }

  saveNote() {
    $.ajax({
      url: `/admin/job_cards/${this.jobId}`,
      method: 'PATCH',
      data: {
        job_card: { notes: this.$notesInput.val() },
        no_need_flash: true,
      },
    })
  }

  saveInternalNote() {
    $.ajax({
      url: `/admin/job_cards/${this.jobId}`,
      method: 'PATCH',
      data: {
        job_card: { internal_notes: this.$internalNotesInput.val() },
        no_need_flash: true,
      },
    })
  }

  initUserNoteToggle() {
    $('#js-edit-user-note').on('click', () => this.toggleUserNoteEdit(true))
    $('#js-cancel-user-note-edit').on('click', () => this.toggleUserNoteEdit(false))
  }

  toggleUserNoteEdit(editing) {
    $('#user-note-display').toggle(!editing)
    $('#user-note-edit').toggle(editing)
  }
}

document.addEventListener('DOMContentLoaded', function () {
  return new JobCardShowView($('.jobs-view'))
})
